import Switch from './Switch';
import { withFormMeta } from '../../FormMeta';

export default withFormMeta(Switch);
